import Reveal from "../Reveal";
import { PrimaryCTA } from "../CTAButton";

export default function FinalCTA() {
  return (
    <section className="ad-section bg-white" data-testid="final-cta">
      <div className="ad-container">
        <div className="relative overflow-hidden rounded-[2rem] bg-[#0B1220] px-6 py-16 text-white sm:px-12 lg:py-24">
          <div className="absolute inset-0 dot-pattern opacity-[0.06]" aria-hidden="true" />
          <div
            className="absolute -right-24 -top-24 h-72 w-72 rounded-full opacity-40 blur-3xl"
            style={{ background: "radial-gradient(circle, rgba(0,199,217,0.5), transparent 70%)" }}
            aria-hidden="true"
          />
          <div className="absolute right-10 top-10 h-2 w-2 rounded-full bg-[#FF6A45]" aria-hidden="true" />
          <div className="relative mx-auto max-w-2xl text-center">
            <Reveal><span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#00C7D9]">Ready when you are</span></Reveal>
            <Reveal index={1}>
              <h2 className="mt-5 display-lg">
                Ready to make your data <span className="text-gradient">work harder?</span>
              </h2>
            </Reveal>
            <Reveal index={2}>
              <p className="mx-auto mt-6 max-w-lg text-base leading-relaxed text-slate-300 sm:text-lg">
                Let's talk about the data, AI or analytics challenge you're trying to solve.
              </p>
            </Reveal>
            <Reveal index={3}>
              <div className="mt-9 flex justify-center">
                <PrimaryCTA to="/consultation" testId="final-cta-button" className="px-8 py-4 text-base">Book a Consultation</PrimaryCTA>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
